<template>
  <div class="remark">
    <div class="tabs-bar">
      <div class="bar-wrap">
        <div :class="['tab', active === 0 ? 'active' : '']" @click="active = 0">
          待点评({{ review }})
        </div>
        <div :class="['tab', active === 1 ? 'active' : '']" @click="active = 1">
          已点评({{ comments }})
        </div>
      </div>
    </div>
    <div class="search">
      <div class="search-input">
        <el-input placeholder="搜索作品名称、作品编号" v-model="worksName">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div class="search-btn" @click="submitCondFilterFn">搜索</div>
    </div>
    <div class="filter">
      <div :class="['timer', sortType !== 0 ? 'checked' : '']" @click="sort">
        <span>时间排序</span>
        <div class="sort-ico">
          <i
            v-if="sortType === 1 || sortType === 0"
            class="el-icon-caret-top"
          ></i>
          <i
            v-if="sortType === 2 || sortType === 0"
            class="el-icon-caret-bottom"
          ></i>
        </div>
      </div>
      <div
        :class="['condition', onCondFilter ? 'checked' : '']"
        @click="openCondBox"
      >
        筛选作品
      </div>
    </div>
    <van-popup
      v-model="conditionShow"
      position="right"
      :style="{ width: '70%', height: '100%' }"
    >
      <div class="condition-filter">
        <div class="cond-handle">
          <div class="reset" @click="resetCond">重置</div>
          <div class="confirm" @click="submitCondFilterFn">确定</div>
        </div>
        <div class="cond-lst">
          <SignTitle title="辅导教师" :simplicity="true" />
          <div>
            <div class="search-input">
              <el-input placeholder="请输入辅导老师姓名/电话" v-model="teacherName">
              </el-input>
            </div>
          </div>
          <SignTitle title="专业" :simplicity="true" />
          <div class="major-lst">
            <div
              :class="['major', major.selected ? 'selected' : '']"
              v-for="(major, i) in majorList"
              :key="i"
              @click="major.selected = !major.selected"
            >
              {{ major.name }}
            </div>
          </div>
          <SignTitle title="组别" :simplicity="true" />
          <div class="group-lst">
            <div
              :class="['group', group.selected ? 'selected' : '']"
              v-for="(group, i) in groupList"
              :key="i"
              @click="group.selected = !group.selected"
            >
              {{ group.name }}
            </div>
          </div>
          <SignTitle title="服务单位" :simplicity="true" />
          <div class="service-lst">
            <div
              :class="['serItem', serItem.selected ? 'selected' : '']"
              v-for="(serItem, i) in serviceUnitList"
              :key="i"
              @click="serItem.selected = !serItem.selected"
            >
              {{ serItem.name }}
            </div>
          </div>
        </div>
      </div>
    </van-popup>

    <div class="works-list">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="works-item" v-for="(item, i) in dataList" :key="i">
          <div class="works-img">
            <img v-setshow :src="item.img" alt="" />
          </div>
          <div class="works-infos">
            <div class="works-tit">
              <div class="tit-infos">
                <div class="works-title">{{ item.title }}</div>
                <div
                  class="slogan"
                  @click.stop="(showSlogan = true), (content = item.slogan)"
                >
                  <div>{{ item.slogan }}</div>
                </div>
              </div>
            </div>
            <div class="author-info">
              <div class="author">
                <p>
                  {{
                    `${item.author} | ${item.majorName} | ${item.groupName} | ${item.teacherName}`
                  }}
                </p>
                <p>报名服务单位：{{ item.organization }}</p>
                <p>上传：{{ item.time }}</p>
              </div>
              <div class="remark-area">
                <div class="btn" v-if="active === 0" @click="checkLock(item)">
                  点评
                </div>
                <div
                  class="btn"
                  v-else
                  @click="
                    $router.push({
                      path: '/judge/remarkpage',
                      query: { id: item.id, isRemark: 1 }
                    })
                  "
                >
                  查看
                </div>
                <!-- <div class="judge">
                  <i class="el-icon-arrow-right" />
                  <img src="../../assets/images/home/unuser_head.svg" alt="" />
                  <img src="../../assets/images/home/unuser_head.svg" alt="" />
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <!-- 简介信息 -->
    <van-popup
      v-model="showSlogan"
      class="slogan"
      closeable
      close-icon="arrow-down"
      close-icon-position="top-right"
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="info-wrap">
        <div class="intro" v-html="content"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import SignTitle from "@/components/pub/SignTitle";
import {
  getUserJudgesData,
  getPageJudgesWorks,
  getJudgesMajorAndGroup,
  getInstitutionList,
  lockCommentWorks
} from "@/utils/api/judge";
export default {
  components: {
    SignTitle
  },
  watch: {
    active: function () {
      this.page = 1;
      this.finished = false;
      this.getPageList(true);
    },
    sortType: function () {
      this.page = 1;
      this.finished = false;
      this.getPageList(true);
    }
  },
  data() {
    return {
      // 0待点评 1已点评
      active: 0,
      // 搜索名称
      worksName: "",
      // 待点评数量
      review: 0,
      // 已点评数量
      comments: 0,
      // 数据列表
      dataList: [],
      // 0默认 1升序 2降序
      sortType: 2,
      // 条件筛选
      onCondFilter: false,
      // 显示筛选窗
      conditionShow: false,
      // 专业列表
      majorList: [],
      // 组别列表
      groupList: [],
      // 服务单位列表
      serviceUnitList: [],
      loading: false,
      finished: false,
      page: 0,
      pageSize: 10,
      showSlogan: false,
      content: "",
      teacherName: ""
    };
  },
  methods: {
    async checkLock(item) {
      const { data } = await lockCommentWorks(item.id);
      if (!data) {
        this.$toast.fail("该作品其他评委正在查看中，请选择其他作品或稍后再试");
      } else
        this.$router.push({
          path: "/judge/remarkpage",
          query: { id: item.id, isRemark: 0 }
        });
    },
    onLoad() {
      this.page++;
      this.getPageList(this.page === 1);
    },
    getServiceUnitList() {
      getInstitutionList().then((res) => {
        if (res.success) {
          this.serviceUnitList = res.data.map((e) => {
            return {
              name: e.name,
              id: e.id,
              selected: false
            };
          });
        }
      });
    },
    // 加载专业组别
    loadMajorGruop() {
      getJudgesMajorAndGroup().then((res) => {
        if (res.success) {
          this.majorList = res.data.swMajorList.map((e) => {
            return {
              name: e.name,
              id: e.id,
              selected: false
            };
          });
          this.groupList = res.data.swGroupList.map((e) => {
            return {
              name: e.name,
              id: e.id,
              selected: false
            };
          });
        }
      });
    },
    // 加载列表
    getPageList(init = false) {
      this.loading = true;
      const mjs = this.majorList
        .filter((e) => {
          return e.selected;
        })
        .map((e) => {
          return e.id;
        });
      const gps = this.groupList
        .filter((e) => {
          return e.selected;
        })
        .map((e) => {
          return e.id;
        });
      const ser = this.serviceUnitList
        .filter((e) => {
          return e.selected;
        })
        .map((e) => {
          return e.id;
        });
      const p = {
        pageNo: this.page,
        pageSize: this.pageSize,
        worksType: this.active,
        timeSort: this.sortType === 2 ? 0 : 1,
        majorIdList: mjs,
        groupIdList: gps,
        institutionIdList: ser,
        name: this.worksName,
        teacherName: this.teacherName
      };
      if (!mjs.length) {
        delete p.majorIdList;
      }
      if (!gps.length) {
        delete p.groupIdList;
      }
      if (!ser.length) {
        delete p.institutionIdList;
      }
      if (!this.worksName) {
        delete p.name;
      }
      if (init) this.dataList = [];
      getPageJudgesWorks(p).then((res) => {
        if (res.success) {
          const loadData = res.data.records.map((e) => {
            return {
              id: e.id,
              img: e.imgs,
              title: e.name,
              author: e.babyName,
              organization: e.institutionName || "无报名服务单位",
              time: e.addTime,
              majorName: e.majorName,
              groupName: e.groupName,
              slogan: e.synopsis,
              teacherName: e.teacherName
            };
          });
          this.dataList.push(...loadData);
        } else {
          this.finished = true;
          this.loading = false;
        }
        this.loading = false;
        if (this.page * this.pageSize >= res.data.total) {
          this.finished = true;
        }
      });
    },
    // 排序
    sort() {
      this.sortType++;
      this.onCondFilter = false;
      if (this.sortType > 2) {
        this.sortType = 0;
      }
    },
    // 打开条件筛选
    openCondBox() {
      this.sortType = 0;
      this.onCondFilter = true;
      this.conditionShow = true;
    },
    // 提交查询数据
    submitCondFilterFn() {
      this.conditionShow = false;
      this.page = 1;
      this.getPageList(true);
    },
    // 重置查询条件
    resetCond() {
      this.majorList.forEach((e) => {
        e.selected = false;
      });
      this.groupList.forEach((e) => {
        e.selected = false;
      });
      this.serviceUnitList.forEach((e) => {
        e.selected = false;
      });
      this.teacherName = "";
    },
    // 获取已评未评数量
    getPageTopBarData() {
      getUserJudgesData().then((res) => {
        if (res.success) {
          this.review = res.data.commentsNum;
          this.comments = res.data.alreadyCommentsNum;
        }
      });
    }
    //
  },
  mounted() {
    this.getPageTopBarData();
    this.loadMajorGruop();
    this.getServiceUnitList();
  }
};
</script>
<style lang="scss" scoped>
.remark {
  display: flex;
  flex-direction: column;
  text-align: left;
  height: calc(100vh - 75px);
  .tabs-bar {
    position: fixed;
    top: 0;
    left: 0px;
    width: 375px;
    height: 52px;
    border-bottom: 1px solid #f2f2f2;
    background: #ffffff;
    box-shadow: 0px 3px 5px rgba(108, 221, 143, 0.26);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    z-index: 20;
    .bar-wrap {
      width: 100%;
      height: 30px;
      border-radius: 15px;
      display: flex;
      overflow: hidden;
      .tab {
        width: 50%;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        color: #054b1b33;
        font-weight: bold;
        &.active {
          color: #6cdd8f;
          &::after {
            content: "";
            height: 2px;
            width: 32px;
            position: absolute;
            bottom: 0;
            left: calc((100% - 32px) / 2);
            background-color: #6cdd8f;
          }
        }
      }
    }
  }

  .search {
    width: 300px;
    height: 50px;
    margin: 0 auto;
    margin-top: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .search-input {
      width: 235px;
      height: 30px;
    }
    .search-btn {
      flex: 1;
      height: 30px;
      justify-content: center;
      display: flex;
      align-items: center;
    }
  }
  .filter {
    height: 50px;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    & > div {
      width: 45%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #999999;
      &.checked {
        position: relative;
        color: #16d77a;
        &::after {
          content: "";
          width: 100%;
          height: 2px;
          background-color: #16d77a;
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
      &:not(.checked) {
        .sort-ico {
          i:last-child {
            margin-top: -7px;
          }
        }
      }
    }
    .timer {
      span {
      }
      .sort-ico {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        height: 100%;
        margin-left: 2px;
      }
    }
    .condition {
    }
  }
  .condition-filter {
    height: 100%;
    width: 100%;
    .cond-lst {
      padding: 0 10px;
      .major-lst,
      .group-lst,
      .service-lst {
        display: flex;
        flex-wrap: wrap;

        .major,
        .group,
        .serItem {
          margin-left: 10px;
          margin-bottom: 10px;
          background-color: #f9f9f9;
          border-radius: 3px;
          text-align: center;
          height: 30px;
          line-height: 30px;
          font-size: 12px;
          color: #999;
          min-width: 50px;
          padding: 0 10px;
          &.selected {
            border: 1px solid #2ccf79;
            color: #2ccf79;
            background-color: #fff;
          }
        }
      }
    }
    .cond-handle {
      height: 40px;
      display: flex;
      width: 100%;
      border-bottom: 1px solid #ebebeb;
      justify-content: space-between;
      & > div {
        height: 100%;
        width: 20%;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        color: #6cdd8f;
      }
    }
  }
  .works-list {
    flex: 1;
    overflow-y: scroll;
    .works-item {
      position: relative;
      height: 145px;
      width: 100%;
      padding: 15px 20px;
      display: flex;
      .works-img {
        width: 84px;
        height: 115px;
        border-radius: 10px;
        overflow: hidden;
        background: #000;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          height: 100%;
        }
      }
      .works-infos {
        position: relative;
        flex: 1;
        margin-left: 8px;
        display: flex;
        flex-direction: column;
        .works-tit {
          position: relative;
          border-bottom: 1px solid #f9f9f9;
          height: 43px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          max-width: 240px;
          .tit-infos {
            * {
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
            .works-title {
              font-size: 14px;
              font-weight: 700;
              color: #666;
            }

            .slogan {
              width: 100%;
              position: relative;
              div {
                font-size: 12px;
                margin: 5px 0;
                color: #999;
                line-height: 20px;
                max-width: 80%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              &::before {
                content: "";
                position: absolute;
                z-index: 1;
                height: 100%;
                width: 10px;
                display: block;
                background: url("../../assets/images/active/icon-right-arr.png");
                background-size: 10px 10px;
                background-position: center center;
                background-repeat: no-repeat;
                top: 0;
                right: 15px;
              }
            }
          }
        }
        .author-info {
          position: relative;
          display: flex;
          justify-content: space-between;
          .author {
            font-size: 12px;
            color: #666;
            max-width: 160px;
            p {
              max-width: 100%;
              text-overflow: ellipsis;
              // overflow: hidden;
              white-space: nowrap;
              line-height: 24px;
              &:first-child {
                color: #fedc01;
              }
            }
          }
          .remark-area {
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            .btn {
              width: 57px;
              height: 20px;
              border-radius: 5px;
              color: #fff;
              text-align: center;
              background: linear-gradient(90deg, #5dd682 0%, #5aff8e 100%);
              opacity: 1;
              border-radius: 11px;
              line-height: 21px;
            }
            .judge {
              display: flex;
              justify-content: flex-end;
              flex-direction: row-reverse;
              margin-top: 10px;
              img {
                width: 15px;
                height: 15px;
                border-radius: 50%;
              }
              i {
                font-size: 15px;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.remark {
  .search-input {
    .el-input {
      .el-input__icon {
        line-height: 32px;
      }
      input {
        background-color: #f2f2f2;
        height: 30px;
        border-radius: 20px;
        border: none;
      }
    }
  }
  .van-popup.slogan {
    border-radius: 20px 20px 0 0;
    overflow-y: hidden;
    .van-icon {
      right: calc((100% - 16px) / 2);
      font-size: 16px;
      &::after {
        content: "";
        position: absolute;
        left: -3px;
        top: -3px;
        height: 20px;
        width: 20px;
        box-sizing: content-box;
        border: 1px solid #c8c9cc;
        border-radius: 50%;
      }
    }
  }
  .info-wrap {
    margin-top: 50px;
    padding: 0 20px;
    height: 100%;
    overflow-y: scroll;
    .intro {
      margin-top: 20px;
      line-height: 24px;
      font-size: 14px;
      color: #999;
      padding-bottom: 80px;
    }
  }
}
</style>
